module.exports = __webpack_public_path__ + "img/only-the-best-clinics.66a44fc9.png";